import { FC } from 'react';
import { ModalColor, ModalIcon, ModalIcons } from '~shared/types/modal';
import cn from 'classnames';
import colorScheme from './colors';

interface IProps {
  name: ModalIcon;
  color?: ModalColor;
  className?: string;
}

const Icon: FC<IProps> = ({
  name,
  color = ModalColor.PRIMARY,
  className = 'w-8 h-8',
}) => {
  const IconComponent = ModalIcons[name] || ModalIcons.FdInfoCircle;
  const colorClassName = `text-${colorScheme[color].icon}`;

  return <IconComponent className={cn(className, colorClassName)} />;
};

export default Icon;
